export const EXTERNAL_LINKS = {
  // ── Shared by domain/purpose ──────────────────────────────────
  LEGAL: {
    /** Used in portal signup, subscriptions (marketing site slug) */
    TERMS_CONDITIONS: 'https://www.ordermentum.com/terms-conditions',
    /** Used in payment forms — SecureCardForm (different slug from TERMS_CONDITIONS) */
    TERMS_AND_CONDITIONS: 'https://www.ordermentum.com/terms-and-conditions',
    PRIVACY_POLICY: 'https://www.ordermentum.com/privacy-policy',
    PRIVACY_COLLECTION_NOTICE:
      'https://www.ordermentum.com/privacy-collection-notice',
    DIRECT_DEBIT_TERMS:
      'https://static.ordermentum.com/mobile/direct-debit-terms.html',
  },
  SUPPORT: {
    EMAIL: 'mailto:support@ordermentum.com',
    CONTACT: 'https://www.ordermentum.com/contact-us',
    /** Address suppliers email to request API token (external integrations) access. */
    INTEGRATIONS_EMAIL: 'api@ordermentum.com',
  },
  HELP: {
    PORTAL: 'https://help.ordermentum.com/',
    SUPPLIER_PORTAL: 'https://help.ordermentum.com/supplier',
    XERO_SYNC:
      'https://help.ordermentum.com/venue/en/articles/9186964-sync-your-ordermentum-invoices-with-xero-for-one-click-bookkeeping',
    MYOB_CONNECT:
      'https://help.ordermentum.com/venue/en/articles/10019575-how-to-connect-myob-to-your-ordermentum-venue-account',
    QUICKBOOKS_CONNECT:
      'https://help.ordermentum.com/venue/en/articles/10019620-connect-quickbooks-to-your-ordermentum-venue-account',
    INVOICE_IMPORT:
      'https://help.ordermentum.com/venue/en/articles/12526593-importing-supplier-invoices-into-ordermentum',
    OMNI_AI:
      'https://help.ordermentum.com/supplier/en/articles/10911005-getting-started-with-omni-ai',
  },
  DEEPLINK: {
    QBR_LOGIN: 'https://order.app.link/qbr-login',
    REWARDS_HELP: 'https://order.app.link/e/rewards-help',
    FIRST_ORDER_GUARANTEE: 'https://order.app.link/e/first-order-guarantee',
    VENUE_ACLS: 'https://order.app.link/e/venue-acls',
    INTEGRATE_XERO: 'https://order.app.link/e/integrate-xero',
    EXPORTS_IMPORTS: 'https://order.app.link/e/exports-imports-printing',
    RESTRICTED_HELP: 'https://order.app.link/restricted-help',
    TAKING_PAYMENTS: 'https://order.app.link/taking-payments',
    CREATING_PROMOTIONS: 'https://order.app.link/e/creating-promotions',
    QUICKBOOKS_ONLINE: 'https://order.app.link/e/quickbooks-online',
    MYOB_BUSINESS: 'https://order.app.link/myob-business',
    SIGNUP_LINKS: 'https://order.app.link/e/signup-links',
    EXPIRED_LEADS: 'https://order.app.link/e/expired-leads',
    BETA_AI_TERMS: 'https://order.app.link/e/beta-ai-terms',
    CREDIT_RATING: 'https://order.app.link/e/credit-rating-insight',
  },
  APP_STORE: {
    GOOGLE_PLAY:
      'https://play.google.com/store/apps/details?id=io.ordermentum.retailer',
    APPLE: 'https://itunes.apple.com/au/app/ordermentum/id1271283718?mt=8',
  },
  WEBSITE: {
    HOME: 'https://app.ordermentum.com/',
    REFERRAL_PROGRAM: 'https://www.ordermentum.com/referral-program',
    REQUEST_DEMO: 'https://www.ordermentum.com/request-a-demo',
    BLOG_MUST_USE_FEATURES:
      'https://www.ordermentum.com/blog/supplier-must-use-features/',
  },
  THIRD_PARTY: {
    XERO_SSO_SCRIPT: 'https://edge.xero.com/platform/sso/xero-sso.js',
    STRIPE_PRICING_SCRIPT: 'https://js.stripe.com/v3/pricing-table.js',
  },

  // ── App-specific (only used in one app) ───────────────────────
  SUPPLIER: {
    REQUEST_CALL_GROWTH_ENGINE:
      'https://order.app.link/e/request-call-growthengine',
    LEARN_MORE_GROWTH_ENGINE:
      'https://order.app.link/e/learn-more-growth-engine',
    REQUEST_INSIGHTS_TRIAL: 'https://order.app.link/e/request-insights-trial',
    /** Growth Engine intake/signup form (supplier onboarding) */
    GROWTH_ENGINE_FORM: 'https://order.app.link/Hx0Fpg7ertb',
  },
} as const;

// Dynamic URL helpers
export const getAbrLookupUrl = (abn: string): string =>
  `https://abr.business.gov.au/ABN/View?abn=${encodeURIComponent(abn)}`;

export const getGoogleMapsSearchUrl = (query: string): string =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

export const getAppleMapsUrl = (address: string): string =>
  `https://maps.apple.com/?address=${encodeURIComponent(address)}`;
